export const WHATSAPP_PHONE_DISPLAY = "722 18 89 16";
export const WHATSAPP_URL = `https://wa.me/34722188916?text=${encodeURIComponent(
  "Hola Nidoria, quiero más información sobre la app de pisos y casas."
)}`;

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const APK_DOWNLOAD_URL = `${API_BASE}/app/apk`;
export const APK_INFO_URL = `${API_BASE}/app/apk/info`;
export const SETTINGS_URL = `${API_BASE}/app/settings`;

export const IMAGES = {
  apartment:
    "https://images.unsplash.com/photo-1661796428215-04fc2830aae6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTIyODkxMDN8MA&ixlib=rb-4.1.0&q=85",
  house:
    "https://images.unsplash.com/photo-1689958270296-0874646defbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxzcGFuaXNoJTIwaG91c2UlMjBwYXRpb3xlbnwwfHx8fDE3OTIyODkxMDh8MA&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1738168246881-40f35f8aba0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxicmlnaHQlMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTIyODkxMDN8MA&ixlib=rb-4.1.0&q=85",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo ha fallado. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
